/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingTransactionRequestContext {
    getFixupPrototypeFunction() { return MasterAccountBillingTransactionRequestContext.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingTransactionRequestContext>): MasterAccountBillingTransactionRequestContext {
        let obj = Object.assign(new MasterAccountBillingTransactionRequestContext(), model);
        MasterAccountBillingTransactionRequestContext.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingTransactionRequestContext>): MasterAccountBillingTransactionRequestContext {
        if (!model) return null;
        return MasterAccountBillingTransactionRequestContext.newInstance(<MasterAccountBillingTransactionRequestContext> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingTransactionRequestContext) {
        if (!obj) return;

        models.MasterAccountBillingTransactionRequestContext.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingTransactionRequestContext): boolean {
        Object.setPrototypeOf(obj, MasterAccountBillingTransactionRequestContext.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.query) {
            models.QueryOperator.fixupPrototype(this.query);
        }
    }

    /**
     * Query expression to filter the transactions
     */
    query: models.QueryOperator;

    /**
     * Start of the transactions period
     */
    start_date: Date;

    /**
     * End of the transactions period
     */
    end_date: Date;

}
